import axiosInstances from '../utils/axiosInstances';

/**
 * @typedef {import('axios').AxiosResponse} AxiosResponse
 */

class RESTClientService {
  #dispatchQoreAxiosInstance;

  constructor() {
    this.#dispatchQoreAxiosInstance = axiosInstances({
      baseURL: process.env.REACT_APP_DISPATCH_QORE_API,
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_NSD_API_KEY
      },
      withCredentials: true
    });
  }

  /**
   * Returns the entire client list used by dispatchQore
   * via the [dbo].[GetDispatchQoreClientList] SPROC in AdminQore DB (not assetmanagement)
   * intended to replace GQL clientService getClients(). Awaiting within the function to
   * return the wrapped data to emulate how the previous GQL call returned data
   * @returns {Promise<AxiosResponse>}
   */
  async getClientList() {
    const response = await this.#dispatchQoreAxiosInstance.get('/getClientList');
    return response?.data;
  }

  /**
   * Get a client from the AdminQore table joined with the necessary workflow information
   * based on companyIdentifier or the PK of the record in AdminQore [dbo].[Companies]
   * @param {number} clientId
   * @param {number} companyIdentifier
   * @returns {Promise<Object>}
   */
  async getClientById(clientId, companyIdentifier = null) {
    const response = await this.#dispatchQoreAxiosInstance.get('/getClientById', {
      params: {
        clientId,
        companyIdentifier
      }
    });
    return response?.data;
  }

  /**
   * @param {string} clientName
   * @returns {Promise<Object>}
   */
  async getClientByName(clientName) {
    const response = await this.#dispatchQoreAxiosInstance.get('/getClientByName', {
      params: {
        clientName
      }
    });
    return response?.data;
  }
}

export default RESTClientService;
